import { AdditionalInfoView } from '../types';
import { IObservableArray } from 'mobx';
import { MutableRefObject } from 'react';

const DEFAULT_TEXT_WIDTH = 280;
const SINGLE_ROW_HEIGHT = 28;
const WIDTH_OF_SCROLL_ELEMENT_EXCLUDING_TEXT = 186;

export const useEstimateRowSize = (
    data: IObservableArray,
    scrollElementRef: MutableRefObject<HTMLDivElement | null>
): {
    calculateTextHeight: (_text: string, _width: number) => number;
    estimateRowSize: (index: number) => number;
    estimateRowsSize: (rows: AdditionalInfoView[]) => number;
} => {
    const calculateTextHeightSimple = (_text: string, _width: number): number => SINGLE_ROW_HEIGHT;

    const textWidth =
        scrollElementRef.current !== null
            ? scrollElementRef.current.clientWidth - WIDTH_OF_SCROLL_ELEMENT_EXCLUDING_TEXT
            : DEFAULT_TEXT_WIDTH;

    const estimateRowSize = (index: number): number =>
        !data[index] ? SINGLE_ROW_HEIGHT : calculateTextHeightSimple(data[index].text, textWidth);

    const estimateRowsSize = (rows: AdditionalInfoView[]): number =>
        rows.reduce((result, { text }) => {
            result += calculateTextHeightSimple(text ?? '', textWidth);
            return result;
        }, 0);

    return { calculateTextHeight: calculateTextHeightSimple, estimateRowSize, estimateRowsSize };
};
